// extracted by mini-css-extract-plugin
export default {"bShadow":"App_bShadow__8dh5B","b2Shadow":"App_b2Shadow__fRr9r","pulse":"App_pulse__1+8c+"};